import React, { Component } from 'react';
import { Element } from 'react-scroll';

class EditorSection extends Component {
  render() {
    return (
      <Element name="editor-section">
        <div className="row">
          <div className="col-lg-7 col-md-8 col-11 mx-auto py-4">
            <h1 className="text-uppercase">Chi sono</h1>
            <div className="separator mx-auto"></div>

            <div className="row mt-4">
              <div className="col-md-4 col-7 mx-auto">
                <img src="/img/ale.png" className="img-fluid" />
              </div>
            </div>

            <p className="text-justify pt-3">Ciao. Mi chiamo Alessio Mantelli, ma non è molto importante. Ricordo che ero poco più di un bambino quando mi avvicinai a quell’oggetto misterioso ma allo stesso tempo affascinante: il libro. Mi ricordo di quando mio padre mi accompagnava al Salone del libro, mi dava i soldi in mano e io compravo quel che volevo. Leggevo e scrivevo, scrivevo e leggevo, ma col tempo, l’esperienza e gli studi mi resi conto che ero più bravo a migliorare i libri degli altri che scriverne di miei.
            Per questo voglio aiutare le persone a far nascere il loro libro, il loro progetto, il loro sogno. Ogni storia contiene un potenziale che, però, viene nascosto sotto virgole mal poste, personaggi con lo stesso nome, dialoghi fiacchi ed errori bizzarri. Se hai bisogno di correzioni, di revisioni o di un’opinione esterna, io posso offrirti il mio aiuto.
            <br/>
            <br/>
            Per sapere nello specifico cosa faccio continua nella sezione Servizi. Se hai deciso di lavorare con me o se hai dubbi, contattami alla mail: almantelli7@gmail.com.</p>
          </div>
        </div>
      </Element>
    );
  }
}

export default EditorSection;



// WEBPACK FOOTER //
// ./src/components/EditorSection.js